<!-- 赛事信息 -->
<template>
    <div>
        <event-head></event-head>
        <div class="infoPage">
            <div v-for="item in matchContent" :key="item.matchSponsorId">
                <normal-card :title="item.matchIntroTypeName" class="mt-5">
                    <div class="overviewCommand_detail">
                        <div class="content-area">
                            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="item.intro.info"></el-input>
                        </div>
                    </div>
                    <el-button type="primary" class="saveBtn" @click="saveContent(item)">保存</el-button>
                </normal-card>
            </div>
        </div>
    </div>
</template>
<script>
import EventHead from '@/common/components/eventHead/EventHead';
import normalCard from '@/common/components/normal/NormalCard';
export default {
    components: { EventHead, normalCard },
    data() {
        return {
            matchContent: [],
            form: {},
            info: "",
            sponsorData: [],
            matchIntroList: [],
            matchIntroTypeId: '',
            title: "",
            sponsorTitle: "",
            posterTitle: "",
            dialogVisible: false,
            sponsorVisible: false,
            posterVisible: false,
            sponsorForm: {},
            posterData: [],
            posterForm: {},
            matchInfo: {}
        };
    },
    mounted() {
        if (localStorage.getItem('matchId')) {
            this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
            this.getMatchIntroList()
        } else {
            this.$confirm('暂无赛事！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
        }
    },
    methods: {
        // 获取分类介绍列表
        async getMatchIntroList() {
            const { res } = await this.$http.get(`/Match/MatchIntroInfoList/${this.matchInfo.matchId}`);
            this.matchContent = res.data || [];
            this.matchContent.map(item => {
                if (item.matchIntroTypeId == 1) {
                    item.matchIntroTypeName = "赛事介绍"
                }
                if (item.matchIntroTypeId == 2) {
                    item.matchIntroTypeName = "比赛奖励"
                }
                if (item.matchIntroTypeId == 3) {
                    item.matchIntroTypeName = "参赛须知"
                }
                if (item.matchIntroTypeId == 4) {
                    item.matchIntroTypeName = "赛制规定"
                }
                if (item.matchIntroTypeId == 5) {
                    item.matchIntroTypeName = "处罚规则"
                }
                if (item.matchIntroTypeId == 6) {
                    item.matchIntroTypeName = "费用说明"
                }
                if (item.matchIntroTypeId == 7) {
                    item.matchIntroTypeName = "关于保险"
                }
                if (item.matchIntroTypeId == 8) {
                    item.matchIntroTypeName = "附加说明"
                }
                if (item.matchIntroTypeId == 10) {
                    item.matchIntroTypeName = "公告"
                }
                if (item.intro == null) {
                    item.intro = {}
                    item.info = ""
                }
            })
        },
        // 保存赛事内容
        saveContent(item) {
            this.form.matchId = this.matchInfo.matchId
            this.form.matchIntroTypeId = item.matchIntroTypeId
            this.form.info = item.intro.info
            console.log(123133, this.form.info)
            this.$confirm('请核实信息，确定要保存赛事内容吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                const { res } = await this.$http.post('/Match/SaveMatchIntro', this.form);
                if (res.isSuccess) {
                    this.$showSuccess('发布成功');
                    this.getMatchIntroList();
                    // Object.keys(this.form).forEach(key => (this.form[key] = ''));
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.infoPage {
    width: 100%;
    height: 100%;
    margin-top: 40px;

    .bread-crumb {
        height: 30px;
    }

    .overviewCommand_detail {
        height: auto;
        width: 100%;

        .list-area {
            margin-top: 10px;
            display: flex;
            width: 100%;
        }

        .top-area {
            display: flex;
            align-items: center;
            color: #fff;
            width: 100%;
            height: 40px;
            font-size: 15px;
            background-color: #10a2db;
            border-radius: 10px 10px 0 0;
        }

        .basic-left {
            margin-top: 10px;
            display: flex;
            align-items: center;
            margin-left: 100px;
            width: 50%;
        }

        .basic-right {
            display: flex;
            align-items: center;
            width: 40%;

            .card-item {
                width: 60%;
                margin-left: 100px;
                height: 240px;
                margin-right: 20px;

                .content-area {
                    height: auto;
                    color: #fff;
                }
            }
        }

        .view-area {
            width: 60%;
            margin: 0 10px;
        }
    }
}

.saveBtn {
    float: right;
    margin-right: 20px;
    margin-bottom: 20px;
}

.info-title {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    background-color: #dbdbdb;

    .markTitle {
        height: 18px;
        width: 5px;
        margin-left: 30px;
        border-radius: 10px;
        background-color: rgb(51, 64, 84);
    }

    .titleImage {
        margin-left: 30px;
        width: 20px;
        height: 20px;
    }

    .title {
        margin-left: 10px;
        color: #409EFF;
        font-size: 15px;
    }
}



.group-name {
    display: flex;
    align-items: center;

    .group {
        width: 5px;
        height: 22px;
        background-color: #2ba245;
        border-radius: 2px;
    }

    .name {
        margin-left: 10px;
        font-weight: 700;
        font-size: 20px;
    }
}

.cardinal {
    margin-top: 30px;
}

.matchDate {
    display: flex;
}

.block {
    margin-right: 60px;
}

.add {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0 10px;
    background-color: #fff;
    border-bottom: 1px solid #a5a1a1;
}

.application-price,
.bond-price {
    display: flex;
    align-items: center;
    width: 300px;
    height: 40px;
    margin: 20px;
    font-size: 18px;
    border: 1px solid #2ba245;
    border-radius: 20px;
}

.cation-title,
.bond-title {
    width: 200px;
    background-color: #2ba245;
    text-align: center;
    line-height: 40px;
    color: #fff;
    border-radius: 18px 0 0 18px;
}

.price,
.bond {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.inputPrice,
.inputBond {
    width: 60%;
    font-size: 14px;
    // background-color: #fff;
}

.matchArea {
    background-color: #fff;
    width: 60%;
    height: 40%;
    border-radius: 10px;
    padding: 20px;
}

.bondTitle {
    display: flex;
    align-items: center;
    font-weight: 400;
    color: #eb7777;
}

.bondIcon {
    width: 30px;
    height: 30px;
    margin-right: 20px;
}

.deduct {
    width: 90%;
    margin: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.redCard,
.yellowCard {
    margin: 30px 10px;
    display: flex;
    align-items: center;
}

.inputDeduct {
    width: 30%;
    margin-left: 10px;
    border-bottom: 1px solid #cfcfcf;
}

.inputMax,
.inputMin {
    margin-left: 10px;
    border-bottom: 1px solid #cfcfcf;
}

.promptText {
    width: 90%;
    color: #2ba245;
    opacity: 0.6;
}

.saveButton {
    background-color: #10a2db;
    width: 150px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    color: #fff;
    font-size: 16px;
}

.statistics {
    background-color: #fff;
    width: 80%;
    height: 40%;
    border-radius: 10px;
    padding: 20px;
}

.enlist,
.cost {
    display: flex;
    justify-content: center;
    font-size: 18px;
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;
}

.feeArea {
    background-color: #fff;
    width: 60%;
    height: 40%;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 30px;
}

.feeSet {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.introduce-area {
    display: flex;
    justify-content: space-around;

    .match-info,
    .match-reward {
        width: 40%;
    }
}

.describe-area {
    margin-top: 60px;
    display: flex;
    justify-content: space-around;

    .match-info,
    .match-reward {
        width: 40%;
    }
}

.group-name {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .group {
        width: 5px;
        height: 20px;
        background-color: #2ba245;
        border-radius: 2px;
    }

    .name {
        margin-left: 10px;
        font-weight: 400;
        font-size: 16px;
    }
}

.operate-btn-com {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 15px;
    border-bottom: 1px solid #333;

    img {
        cursor: pointer;
    }
}

.schedule-table {
    flex: 1;

    /deep/ .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 48px);
    }
}

.sponsor {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .sponsorName,
    .sponsorType {
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
}

.submit-btn {
    width: 200px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #2ba245;
    border: none;
}

.btn-com {
    display: flex;
    justify-content: center;
    margin-top: 30px;

    .save-btn {
        color: #fff;
        background: rgb(51, 64, 84);
        width: 120px;
    }
}
</style>